import { createPatchedMastraClient } from './mastra-client-patch'
import { agentsBaseUrl } from './agentsBaseUrl'
import * as locationService from 'src/services/location'
import { getSession } from '../session'
import { MastraClient } from '@mastra/client-js'

export * from '@mastra/client-js'

const partner = locationService.getPartner()
const baseDomain = window.settings.BASE_AGENTS_DOMAIN.replace('agents.', '')

export const baseURL = `${agentsBaseUrl}/`

let abortController = new AbortController()

export const mastraClient: MastraClient = createPatchedMastraClient({
  baseUrl: baseURL,
  abortSignal: abortController.signal,
  headers: {
    ['X-CRM-Subdomain']: partner,
    ['X-CRM-Base-Domain']: baseDomain,
  },
})

export const mastraClentCancel = () => {
  abortController.abort()
  abortController = new AbortController()
  mastraClient.options.abortSignal = abortController.signal
}
export const mastraClientAuth = () => {
  const session = getSession()

  mastraClient.options.headers = { ...mastraClient.options.headers }
  mastraClient.options.headers[
    'X-CRM-Auth-Token'
  ] = `Bearer ${session.accessToken}`
}

export const CRM_AGENT_ID = 'crmAgent'
export const CRMAgent = mastraClient.getAgent(CRM_AGENT_ID)
